import React, { Fragment, useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { Box, IconButton } from "@mui/material";
import { TagWarningInfo } from "./TagWarningInfo";

export const CustomSection = ({ title, children, collapsable = false, announcement, headerRightContent }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const TitleContainer = headerRightContent ? Box : Fragment;
  
  const titleContainerProps = TitleContainer === Box
  ? { sx: { display: "flex", alignItems: "center", width: "100%" } }
  : {};

  return (
    <Box
      component="section"
      sx={{
        p: "20px",
        mb: "20px",
        bgcolor: "white",
        borderRadius: "10px",
        "& > h3": {
          margin: 0,
          mb: "20px",
        },
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        gap="10px"
        width={(collapsable && !headerRightContent) ? "max-content" : "100%"}
      >
        <TitleContainer {...titleContainerProps}>
          {announcement && (<Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
            <h3 style={{ width: "50%" }}>{title}</h3>
            <Box sx={{ width: "50%" }}>
              <TagWarningInfo text={announcement} />
            </Box>
          </Box>)}
          {!announcement && (<h3>{title}</h3>)}
          {collapsable && (
            <IconButton onClick={() => setIsCollapsed(!isCollapsed)} size="small">
              {isCollapsed ? (
                <ArrowDropDownIcon />
              ) : (
                <ArrowDropUpIcon />
              )}
            </IconButton>
          )}
        </TitleContainer>
        {headerRightContent && (
          <Box>
            {headerRightContent}
          </Box>
        )}
      </Box>
      {(!collapsable || !isCollapsed) && (
        <Box display="flex" flexDirection="column" gap="20px">
          {children}
        </Box>
      )}
    </Box>
  );
};
